<template>
    <rkm-modal
        ref="Modal"
        title="Especialidades"
    >
        <Form
            :data="data"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>